module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-64.bd40daab.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-leaderboards-64.png
// module id = 3199
// module chunks = 11